import React from "react";
import { Navigate } from "react-router-dom";

// REDUX
import { useDispatch, useSelector } from "react-redux";
import { signOut } from "../../../redux/actions/authActions";
// import { signInWithEmailLink_ } from "../../redux/actions/authActions";

// NAVIGATE
import { useNavigate } from "react-router-dom";

const LogOut = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const signOut_rd = (item) => dispatch(signOut(item));

  return (
    <>
      <div className="w-full flex justify-center items-center h-[60px]">
        <div className="w-[900px] h-full border-b-[1px] border-black"></div>
      </div>
      <div className="w-full flex justify-center">
        <div className="w-[800px] h-[250px] mt-[90px]">
          <p className="text-2xl text-center w-full font-Poppins-SemiBold">Êtes-vous sûr de vouloir vous déconnecter ?</p>
          <p className="w-full text-center text-gray-500 mt-[20px]">Vous pouvez revenir à n'importe quel moment.</p>
          <div className="w-full flex justify-center mt-[60px]">
            <button
              onClick={() => {
                signOut_rd();
                navigate("/");
              }}
              className="bg-mainGreen rounded-xl w-[200px] h-[40px] text-white font-Poppins-SemiBold text-sm"
            >
              Se déconnecter
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LogOut;
